import request from '@/utils/request'

// 分页查询组件类型列表
export function paginationSettingComponentType(query = {}, pagination) {
  return request({
    url: `/system/settingComponentType/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 不分页查询组件类型列表
export function listSettingComponentType(query = {}) {
  return request({
    url: '/system/settingComponentType/list',
    method: 'post',
    data: query
  })
}

// 查询组件类型详细
export function getSettingComponentType(componentTypeId) {
  return request({
    url: '/system/settingComponentType/info/' + componentTypeId,
    method: 'get'
  })
}

// 新增组件类型
export function addSettingComponentType(data) {
  return request({
    url: '/system/settingComponentType/add',
    method: 'post',
    data: data
  })
}

// 修改组件类型
export function updateSettingComponentType(data) {
  return request({
    url: '/system/settingComponentType/edit',
    method: 'put',
    data: data
  })
}

// 删除组件类型
export function delSettingComponentType(componentTypeId) {
  return request({
    url: '/system/settingComponentType/remove/' + componentTypeId,
    method: 'delete'
  })
}
